import React, { useCallback, useMemo, useReducer } from 'react';
import DV                                          from 'ts-data-validator';

import newsConstants    from './news.constants';
import NewsContext      from './news.context';
import newsReducer      from './news.reducer';
import newsInitialState from './news.state';

import useRequest from '../../common/services/request';

/**
 * @type {React.FC}
 */
function NewsProvider({
  children,
  value,
}) {
  const [state, dispatch] = useReducer(newsReducer, {
    ...newsInitialState,
    items:              value.items || newsInitialState.items,
    headItems:          value.headItems || newsInitialState.headItems,
    count:              value.count || newsInitialState.count,
    article:            !DV.isUndefined(value.article) ? {
      buttonLink:        value.article.buttonLink || newsInitialState.article.buttonLink,
      buttonName:        value.article.buttonName || newsInitialState.article.buttonName,
      contactButtonName: value.article.contactButtonName || newsInitialState.article.contactButtonName,
      newsId:            +value.article.newsId || newsInitialState.article.newsId,
      label:             value.article.label || newsInitialState.article.label,
      headImage:         value.article.headImage || newsInitialState.article.headImage,
      content:           value.article.content || newsInitialState.article.content,
      createdAt:         value.article.createdAt || newsInitialState.article.createdAt,
      createdAtIso:      value.article.createdAtIso || newsInitialState.article.createdAtIso,
      updatedAtIso:      value.article.updatedAtIso || newsInitialState.article.updatedAtIso,
      readingTime:       value.article.readingTime || newsInitialState.article.readingTime,
      relatedNews:       value.article.relatedNews || newsInitialState.article.relatedNews,
      meta:              {
        title: value.article.metaTitle || newsInitialState.article.meta.title,
        meta:  {
          keywords:    value.article.metaKeywords || newsInitialState.article.meta.meta.keywords,
          description: value.article.metaDescription || newsInitialState.article.meta.meta.description,
          canonical:   value.article.metaCanonical || newsInitialState.article.meta.meta.canonical,
        },
      },
    } : { ...newsInitialState.article },
    detailLoaded:       !DV.isUndefined(value.article),
    initialStateLoaded: DV.isNotEmptyArray(value.items),
  });
  const { get }           = useRequest();

  const getNewsDetail = useCallback((urlKey) => {
    dispatch({ type: newsConstants.GET_NEWS_DETAIL_REQUEST });

    return get(`/api/novosti/${urlKey}`)
      .then((response) => dispatch({ type: newsConstants.GET_NEWS_DETAIL_SUCCESS, ...response }))
      .catch((error) => dispatch({ type: newsConstants.GET_NEWS_DETAIL_FAILURE, ...error }));
  }, [dispatch]);

  const getNewsList = useCallback(() => {
    dispatch({ type: newsConstants.GET_NEWS_LIST_REQUEST });

    return get('/api/novosti')
      .then((response) => dispatch({ type: newsConstants.GET_NEWS_LIST_SUCCESS, ...response }))
      .catch((error) => dispatch({ type: newsConstants.GET_NEWS_LIST_FAILURE, ...error }));
  }, [dispatch]);

  const resetNewsDetail = useCallback(() => {
    dispatch({ type: newsConstants.NEWS_DETAIL_RESET_INITIAL_STATE });
  }, [dispatch]);

  const showMore = useCallback((page, limit) => {
    dispatch({ type: newsConstants.NEWS_SHOW_MORE_REQUEST });

    const url = `/api/novosti?page=${page + 1}&limit=${limit}`;

    return get(url)
      .then((response) => dispatch({
        type: newsConstants.NEWS_SHOW_MORE_SUCCESS, ...response,
        page: page + 1,
      }))
      .catch((error) => dispatch({ type: newsConstants.NEWS_SHOW_MORE_FAILURE, ...error }));
  }, [dispatch]);

  const context = useMemo(() => (
    {
      ...state,
      getNewsDetail,
      getNewsList,
      resetNewsDetail,
      showMore,
    }), [getNewsDetail, getNewsList, resetNewsDetail, showMore, state]);

  return (
    <NewsContext.Provider value={context}>
      {children}
    </NewsContext.Provider>
  );
}

export default NewsProvider;